import styled from "styled-components"

const ContentBlock = ({children, ...props}) => {

	return (
		<Wrapper {...props}>
			<Content {...props}>
				{children}
			</Content>
		</Wrapper>
	)
}

export default ContentBlock

const Wrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    background-color: ${props => props.background ?? 'transparent'};
    padding-top: ${props => props.top ?? 6.66}rem;
    padding-bottom: ${props => props.bottom ?? 6.66}rem;
    @media (max-width: 992px) {
        padding-top: ${props => props.top ?? 2.22}rem;
        padding-bottom: ${props => props.bottom ?? 2.22}rem;
    }
`
const Content = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    max-width: 1320px;
    padding: 0 1.5rem;
    gap: ${props => typeof props.gap !== "undefined" ? props.gap : 6.66}rem;
    @media (max-width: 992px) {
        gap: 3.33rem;
        padding: 0 0.75rem;
    }
`